import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import { get } from "../helper/helper_api";
import { toast } from "react-toastify";
import Loader from "../components/Loader";

export default function ContactUs() {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    if (!loading) {
      setLoading(true);
      get("/contact/list")
        .then(res => {
          setLoading(false);
          if (res?.statusCode == 200)
            setData(res?.data);
          else
            toast.error(res?.error);
        })
        .catch(err => {
          console.log("error while getting contact tables", err);
          toast.error("Something Went Wrong!");
          setLoading(false);
        })
    }
  }

  return (
    <div className="slider-wrapper">
      <div className="container">
        <Loader visible={loading} />
        <div className="row mt63">
          <div className="col-sm-12">
            <div className="mainbdr whitebg">
              <div className="row">
                <div className="col-sm-3">
                  <Sidebar />
                </div>
                <div class="col-sm-9 " style={{ marginTop: "5px" }}>
                  <div class="row mt0">
                    <div class="col-sm-12">
                      <div class="inner_content contactpage">
                        <h2>Contact us</h2>
                        {data?.map((item, index) => (
                          <>
                              <h3 style={{ textAlign: "center" }}>
                                {item?.title}
                              </h3>
                            <div class="clearfix"></div>
                            <table>
                              <thead>
                                <tr>
                                  <th>Sr. No.</th>
                                  <th>Name</th>
                                  <th>Designation</th>
                                  <th>Tel. No.</th>
                                  <th>Fax No.</th>
                                  <th>{item?.title.indexOf("OFFICIAL") != -1 ? "Email" : "Remarks"}</th>
                                </tr>
                              </thead>
                              <tbody>
                                {item?.members?.map((mem, inde) => (
                                  <tr>
                                    <td>{inde + 1}</td>
                                    <td>{mem?.name}</td>
                                    <td>{mem?.designation}</td>
                                    <td>{mem?.mobile}</td>
                                    <td>{mem?.fax}</td>
                                    <td>{mem?.remark}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </>
                        ))}
                        <div class="clearfix"></div>
                        <br />
                        <table>
                          <thead>
                            <tr>
                              <th></th>
                              <th style={{textAlign: 'center'}}>REGISTERED OFFICE</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td></td>
                              <td style={{textAlign: 'center'}}>
                                IDPL Corporate office, IDPL Complex, <br />

                                Old Delhi Gurgaon Road, Dundahera,<br />

                                Gurgaon- 122016 (Haryana)
                              </td>
                            </tr>
                            
                          </tbody>
                        </table>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <Footer />
            </div>

            <div className="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
